export default () => ({
  zipcode: {
    pattern: { message: 'Enter a 5 digit Zip code', value: /^[0-9]{5}$/ },
    required: { message: 'Zip code is required', value: true }
  }
});